module.exports = __webpack_public_path__ + "img/Background1.da7a5d54.png";